export const selectClients = ({ clients }) => clients.clients;
export const selectNewClient = ({ clients }) => clients.client;
export const selectDeletedClient = ({ clients }) => clients.client;
export const selectUsersOnClient = ({ clients }) => clients.usersClient;
export const selectLocationsOnClient = ({ clients }) => clients.locationsClient;
export const selectSurveysOnClient = ({ clients }) => clients.surveysClient;
export const selectUsersOnClient2 = ({ users }) => users.data;
export const selectCurrentLocations = ({ clients }) => clients.locations;
export const selectSurveys = ({ surveys }) => surveys.data;
